<script>
import { keyboardKeyEvents } from '@/helpers/constants';
export default {
	data() {
		return {
			keyboardKeyEvents,
			currentFocusedElem: -1
		};
	},
	methods: {
		focusFirstItem() {
			this.currentFocusedElem = 0;
		},
		focusLastItem() {
			this.currentFocusedElem = this.options.length - 1;
		},
		focusNextItem() {
			this.currentFocusedElem++;
		},
		focusPrevItem() {
			this.currentFocusedElem--;
		}
	}
};
</script>
